import {post} from '../interceptor'

let preUrl = '/energyReport';
export default {
  getEnergyForm(params) { return post(preUrl, '/getEnergyForm', params) },
  getPowerForm(params) { return post(preUrl, '/getPowerForm', params) },
  getDemandForm(params) { return post(preUrl, '/getDemandForm', params) },
  getExpenseForm(params) { return post(preUrl, '/getExpenseForm', params) },
  getParamForm(params) { return post(preUrl, '/getParamForm', params) },
  getAnalyzeReport(params) { return post(preUrl, '/getAnalyzeReport', params) },
  getYuxingEnergyReport(params) { return post(preUrl, '/yuxingReport/getEnergyReport', params) }
}



// WEBPACK FOOTER //
// ./src/api/energy/energyReport.js